const RouteEndPoint = process.env.REACT_APP_ROUTE_ENDPOINT || ""
export const Image_Url = {
    TVSADMIN: `${RouteEndPoint}/Img/tvs_logo.svg`,
    TVSLOGO:`${RouteEndPoint}/Img/tvslogo.svg`,
    MOTOCONNECT_LOGO:`${RouteEndPoint}/Img/moto_connect.svg`,
    TVSADMIN:`${RouteEndPoint}/Img/tvsadmin.svg`,
    Arrow:`${RouteEndPoint}/Img/arrow.svg`,
    LOGINBUTTON:`${RouteEndPoint}/Img/loginbutton.svg`,
    LOGIINICONS:`${RouteEndPoint}/Img/loginn.svg`,
    TVSFOOTER:`${RouteEndPoint}/Img/tvsfooter.svg`,
    PROFILE:`${RouteEndPoint}/Img/profile.svg`,
    BELL:`${RouteEndPoint}/Img/Bell.svg`,
    TVSDASHBOARD:`${RouteEndPoint}/Img/TVS _ Dashboard.svg`,
    PGMLIST:`${RouteEndPoint}/Img/pgmlist.svg`,
    PROFILESIDEBAR:`${RouteEndPoint}/Img/profilesidebar.svg`,
    PGMDETAILSICONS:`${RouteEndPoint}/Img/profilepgmdetails.svg`,
    PGMDETAILS_ADDICON:`${RouteEndPoint}/Img/pgmdeatailsaddicons.svg`,
    PGMDETAILSMINUSICONS:`${RouteEndPoint}/Img/pgmdetails_minus.svg`,
    VERIFICATIONID:`${RouteEndPoint}/Img/verification_img.svg`,
    STORES1:`${RouteEndPoint}/Img/stores1.svg`,
    STORES2:`${RouteEndPoint}/Img/stores2.svg`,
    STORES3:`${RouteEndPoint}/Img/stores3.svg`,
    STORES4:`${RouteEndPoint}/Img/stores4.svg`,
    PASSWORDICON:`${RouteEndPoint}/Img/passwordicon.svg`,
    BORDER:`${RouteEndPoint}/Img/border.svg`,
    QUERYFEEDBACK:`${RouteEndPoint}/Img/queryfeedback.svg`,
    ORG:`${RouteEndPoint}/Img/org.svg`,
    ANNOUNCMENT:`${RouteEndPoint}/Img/Announcments.svg`,
    PRODUCTTRAINING:`${RouteEndPoint}/Img/Product_training.svg`,
    SELLERLIST:`${RouteEndPoint}/Img/sellerslist.svg`,
    CATEGORIES:`${RouteEndPoint}/Img/categories.svg`,
    PGMDEALERS:`${RouteEndPoint}/Img/pgmdealers.svg`,
    VERIFICATIONIDTYPE:`${RouteEndPoint}/Img/Verification ID _Type _.svg`,
    PERSONALINFOMATION:`${RouteEndPoint}/Img/personalinformation.svg`,
    PROFILESIDEBAR:`${RouteEndPoint}/Img/profilesidebar.svg`,
    CROSSICONS:`${RouteEndPoint}/Img/cross.svg`,
    CROSSICONSRED:`${RouteEndPoint}/Img/crossred.svg`,
    PERSONALINFOMATION:`${RouteEndPoint}/Img/personalinformation.svg`,
    PERSONALPROFILE:`${RouteEndPoint}/Img/personalprofiles.png`,
    PEROSNALSECURITY:`${RouteEndPoint}/Img/securitypersonal.svg`,
    DATEICONS:`${RouteEndPoint}/Img/dateicons.svg`,
    PHONEICONS:`${RouteEndPoint}/Img/phone_numbers.svg`,
    GREATERICONS:`${RouteEndPoint}/Img/greatericons.svg`,
    VERIFICATIONDOCUMENTS:`${RouteEndPoint}/Img/verification_documents.svg`,
    CROSSICON:`${RouteEndPoint}/Img/crossicons.svg`,
    PRIVACY:`${RouteEndPoint}/Img/I accept the privacy policy..svg`,
    OPEN_IMG:`${RouteEndPoint}/Img/Group 1447.svg`,
    DOWNNLOADPARTS:`${RouteEndPoint}/Img/downloadparts.svg`,
    UPLOADPARTS:`${RouteEndPoint}/Img/uploadparts.svg`,
    QUESTIONS:`${RouteEndPoint}/Img/question_s.svg`,
    DOWNLOADS:`${RouteEndPoint}/Img/download.svg`,
    TYPE:`${RouteEndPoint}/Img/type_Vector.svg`,
    THUMBNIL1:`${RouteEndPoint}/Img/Vide player.svg`,
    THUMBNIL2:`${RouteEndPoint}/Img/Vide player1.svg`,
    LEFTBUTTON:`${RouteEndPoint}/Img/leftbuttons.svg`,
    RIGHTBUTTON:`${RouteEndPoint}/Img/rightbuttons.svg`,
    DOWNLOADORDER:`${RouteEndPoint}/Img/downloadsorders.svg`,
    PARTCATELOGUE:`${RouteEndPoint}/Img/PartCatelogueScooty.svg`,
    ACKNOWLEDGEORDER:`${RouteEndPoint}/Img/acknowledgeordack.svg`,
    EXCELPHOTO:`${RouteEndPoint}/Img/excelpopup.png`,
    CROSSPOP:`${RouteEndPoint}/Img/crosspop.svg`,
    ADDDISPATCH:`${RouteEndPoint}/Img/adddispatch.svg`,
    DOWNLOADSBUTT:`${RouteEndPoint}/Img/downloadsbutt.svg`,
    DEXCEL:`${RouteEndPoint}/Img/dexcel.svg`,
    CAMRA: `${RouteEndPoint}/Img/camra.svg`,
    PROFILEPLUS:`${RouteEndPoint}/Img/profileplus.svg`,
    COMPLTE_TICK:`${RouteEndPoint}/Img/complete-tick.svg`,
    ADD_ICONS:`${RouteEndPoint}/Img/addicons.svg`,
    PLUS_ICONS:`${RouteEndPoint}/Img/Plusbusiness.svg`,
    IMAGE_ADD:`${RouteEndPoint}/Img/Image_Add.svg`,
    DELETE_STORE_IMAGE:`${RouteEndPoint}/Img/image_deleteCross.svg`,
    INFORMATION:`${RouteEndPoint}/Img/info.svg`,
    DEFAULT_STORE_IMAGE:`${RouteEndPoint}/Img/defaultstoreimage.png`,
    DUMMYCATALOGUE:`${RouteEndPoint}/Img/dummycatalogue.png`,
    LOGOUTICON:`${RouteEndPoint}/Img/logout.png`,
    VIDEO_THUMBNAIL:`${RouteEndPoint}/Img/video_thumbnail.png`,
    PDF_THUMBNAIL:`${RouteEndPoint}/Img/pdf_thumbnail.svg`,
    KDMHEADER:`${RouteEndPoint}/Img/kdmheader.png`,
    KDMFOOTER:`${RouteEndPoint}/Img/kdmfooter.png`,
    MANAGETEAMS:`${RouteEndPoint}/Img/manage-teams.png`,
    NOTIFICATIONICON:`${RouteEndPoint}/Img/notification-icon.png`
  }